import {Text} from "@pg-design/text-module";

import type {IConsentTemplate} from "../types";
import {getConsentContent} from "../utils/get_consent_content";
import {ConsentFileLink} from "./ConsentFileLink";

interface IProps {
    template: IConsentTemplate;
    className?: string;
}

export const DefaultConsentNotice = ({template, className}: IProps) => (
    <Text variant="info_txt_1" align="center" className={className}>
        {getConsentContent(template)}
        {template.file && template.file_link_text ? (
            <>
                <br />
                <ConsentFileLink template={template} />
            </>
        ) : null}
    </Text>
);
import {Text} from "@pg-design/text-module";

import type {IConsentTemplate} from "../types";
import {getConsentContent} from "../utils/get_consent_content";
import {ConsentFileLink} from "./ConsentFileLink";

interface IProps {
    template: IConsentTemplate;
    className?: string;
}

export const DefaultConsentNotice = ({template, className}: IProps) => (
    <Text variant="info_txt_1" align="center" className={className}>
        {getConsentContent(template)}
        {template.file && template.file_link_text ? (
            <>
                <br />
                <ConsentFileLink template={template} />
            </>
        ) : null}
    </Text>
);
